module.exports = require("./dist/utils/create-icon");
